'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function NegotiatedSeatsController(BusComponent, Toast, $scope, UserComponent, $filter) {
	'ngInject';

	var vm = this;
	vm.fetchUsers = UserComponent.fetchUsers;
	vm.clearUserResults = UserComponent.clearUsers;
	vm.getUsers = UserComponent.getUsers;
	vm.buses = [];
	vm.seats = [];
	vm.reservedSeats = [];
	vm.ocupiedSeats = [];
	vm.showBusSchema = false;
	vm.selectedUserError = false;
	vm.seatsCount = 0;
	vm.selectUser = selectUser;
	vm.searchBus = searchBus;
	vm.getBusses = getBusses;
	vm.selectSeat = selectSeat;
	vm.submitReservation = submitReservation;
	vm.clearUserReservations = clearUserReservations;
	vm.searchItems = {
		'bus_id': '',
		'user_id': ''
	};
	var userReservation = {
		'user_id': '',
		'seats': []
	};

	getBusses();

	/** Select user from auto complite and set current user
  * @params { Object } - user - selected user object
 */
	function selectUser(user) {
		vm.userQuery = user.name || user.names;
		vm.searchItems.user_id = user.user[0].id;
		vm.selectedUserName = user.name || user.names;
		vm.selectedUserError = false;
	}

	/** Search for busses
  * @params { Array } - searchParams hlds user_id and bus_id
 */
	function searchBus(searchParams) {
		clear();
		BusComponent.fetchAgreedSeats(vm.searchItems).then(function (data) {
			vm.ocupiedSeats = data;
			generateOcupiedSeatsArray(vm.ocupiedSeats);
			vm.showBusSchema = true;
		});
		for (var i in vm.buses) {
			if (vm.buses[i].id === parseInt(searchParams.bus_id, 10)) {
				vm.seatsCount = parseInt(vm.buses[i].seats, 10);
			}
		}
	}

	/** Generate Array of acupied seats
  * @params { Array } seatsArray - array of ocupied seats
  * @return { Array } vm.reservedSeats - generated array
 */
	function generateOcupiedSeatsArray(seatsArray) {

		for (var i = 0, k = seatsArray.length; i < k; i++) {
			var seatIndex = _lodash2['default'].findIndex(vm.reservedSeats, { 'user_id': seatsArray[i].user_id });

			if (seatIndex === -1) {
				vm.reservedSeats.push(reservationConstructor(seatsArray[i].user_id, seatsArray[i].number));
			} else {
				vm.reservedSeats[seatIndex].seats.push(seatsArray[i].number);
			}
		}

		return vm.reservedSeats;
	}

	/** Get all busses used in dropdown */
	function getBusses() {
		if (Object.keys(vm.buses).length === 0) {
			BusComponent.fetchBuses().then(function () {
				vm.buses = BusComponent.getBuses();
				return vm.buses;
			});
		}
	}

	/** Seat click handler
  * @param { Object } - seat selected seat
  */
	function selectSeat(seat) {
		if (Object.keys(vm.reservedSeats).length > 0 && vm.searchItems.user_id) {
			for (var i = 0, k = vm.reservedSeats.length; i < k; i++) {

				if (vm.reservedSeats[i].user_id === parseInt(vm.searchItems.user_id, 10)) {
					var seatIndex = vm.reservedSeats[i].seats.indexOf(seat.number);

					if (seatIndex === -1 && !seat.user_id) {
						vm.reservedSeats[i].seats.push(seat.number);
						lockedSeat(seat);
					} else if (seat.user_id === vm.searchItems.user_id) {
						vm.reservedSeats[i].seats.splice(seatIndex, 1);
						freeSeat(seat);
					} else {
						getSeatUserName(seat.user_id);
					}

					return false;
				} else if (getSeatIndex() === -1) {
					vm.reservedSeats.push(reservationConstructor(vm.searchItems.user_id, seat.number));
					lockedSeat(seat);
				}
			}
		} else if (!vm.searchItems.user_id) {
			Toast.error($filter('translate')('NEGOTIATED.ERROR.USER_ERROR'));
			vm.selectedUserError = true;
		} else {
			vm.reservedSeats.push(reservationConstructor(vm.searchItems.user_id, seat.number));
			lockedSeat(seat);
		}
	}

	/** Set seat as locked
  * @params { Object } seat - choosen seat (free)
  * @return { Object } seat - seat set as locked
 */
	function lockedSeat(seat) {
		seat.active = true;
		seat.color = 'locked';
		seat.status = 'locked';
		!seat.user_id ? seat.user_id = vm.searchItems.user_id : null;

		return seat;
	}

	/** Set seat as free
  * @params { Object } seat - choosen seat (ocupied)
  * @return { Object } seat - seat set as free
  */
	function freeSeat(seat) {
		seat.active = false;
		seat.color = 'free';
		seat.status = 'free';
		seat.user_id = null;

		return seat;
	}

	/** Construct reservation object
  * @params { Number } userId - id of selected user
  * @params { Number } satNumber - number of selected seat
  * @return { Object } userReservation - reservation object
 */
	function reservationConstructor(userId, seatNumber) {
		userReservation = {
			'user_id': userId,
			'seats': [seatNumber]
		};

		return userReservation;
	}

	/** Get reserved seat index by useer id
  * @return { Number } reservedSeatIndex - index of object that holds user id of seat holder.
 */
	function getSeatIndex() {
		var reservedSeatIndex = _lodash2['default'].findIndex(vm.reservedSeats, { 'user_id': vm.searchItems.user_id });

		return reservedSeatIndex;
	}

	/** Get user name by user ID
  * @params { Number } - id - id of seat holder
  * @return { Object } user object
  */
	function getSeatUserName(id) {
		vm.fetchUsers().then(function () {
			for (var i = 0, k = vm.getUsers().length; i < k; i++) {
				if (vm.getUsers()[i].user[0].id === id) {
					Toast.error(' ' + $filter('translate')('NEGOTIATED.ERROR.OCUPIED_SEAT') + ' ' + (vm.getUsers()[i].name ? vm.getUsers()[i].name.toUpperCase() : vm.getUsers()[i].names.toUpperCase()));
					return;
				}
			}
		});
	}

	/** Clear all inputs and info on submit */
	function clear() {
		userReservation = {
			'user_id': '',
			'seats': []
		};
		vm.reservedSeats = [];
		vm.userQuery = '';
		vm.searchItems.user_id = '';
		vm.showBusSchema = false;
		vm.selectedUserName = '';
	}

	/** */
	function clearUserReservations(userId) {
		var userIndex = _lodash2['default'].findIndex(vm.reservedSeats, { 'user_id': userId });

		if (userIndex !== -1 && confirm($filter('translate')('NEGOTIATED.CONFIRM_MESSAGE'))) {
			vm.reservedSeats[userIndex].seats = [];
			submitReservation('deleteUserReservations');
		}
	}

	/** Submit created reservtion */
	function submitReservation(from) {

		if (vm.reservedSeats.length || vm.searchItems.user_id !== '') {
			BusComponent.createAgreedSeats(vm.searchItems.bus_id, vm.reservedSeats).then(function () {
				if (!from) {
					Toast.success($filter('translate')('NEGOTIATED.SUCCESS.RESERVATION_CREATED'));
				} else {
					Toast.success($filter('translate')('NEGOTIATED.SUCCESS.SEATS_DELETED'));
				}
				clear();
				vm.searchItems = {
					'bus_id': '',
					'user_id': ''
				};
			});
		} else {
			Toast.error($filter('translate')('NEGOTIATED.ERROR.NO_SEATS_SELECTED'));
		}
	}
}

exports['default'] = NegotiatedSeatsController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/negotiated-seats/negotiated-seats.controller.js
 **/